/**
 * Bulk connector enable/disable mutation (P55.2 #598).
 *
 * Calls POST /v1/admin/twin/connectors/bulk-update with body
 * {connector_ids, enabled}. Cache invalidates the connectors list
 * on success.
 */
import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { UseMutationResult } from "@tanstack/react-query";

import { api } from "shared/api/client";

export interface BulkUpdateConnectorsInput {
  connector_ids: string[];
  enabled: boolean;
}

export interface BulkUpdateConnectorsOutput {
  requested: number;
  found: number;
  changed: number;
  unchanged: number;
  not_found_ids: string[];
}

export function useBulkUpdateConnectors(): UseMutationResult<
  BulkUpdateConnectorsOutput,
  Error,
  BulkUpdateConnectorsInput
> {
  const qc = useQueryClient();
  return useMutation<BulkUpdateConnectorsOutput, Error, BulkUpdateConnectorsInput>({
    mutationFn: (body: BulkUpdateConnectorsInput) =>
      api.post<BulkUpdateConnectorsOutput>(
        "/v1/admin/twin/connectors/bulk-update",
        body,
      ),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ["admin-connectors"] });
    },
  });
}
